import { TOGGLE_ONBOARDING_MODAL, TOGGLE_ASPERA_MODAL } from "@actions/modals"

export const toggleOnboardingModal = () => dispatch => dispatch({ type: TOGGLE_ONBOARDING_MODAL })
export const toggleAsperaModal = () => dispatch => dispatch({ type: TOGGLE_ASPERA_MODAL })
